export default __webpack_public_path__ + "static/media/yealink-wp60.b2f4a1a3.png";